<template>
  <div class="d-activity-actions">
    <DuiContextMenu
      ref="contextMenu"
      class="more-options space-left-1em"
      :options-width="150"
    >
      <template slot="trigger">
        <a class="button button-sm button-white">
          <DuiIconEllipsis />
        </a>
      </template>
      <template slot="options">
        <ul>
          <li>
            <a
              :disabled="isProcessing"
              @click.stop.prevent="copyLinkToPost"
            >Copy link to post</a>
          </li>
          <li v-if="!(activity.is_owner || (activity.source && activity.source.is_owner))">
            <a
              :disabled="isProcessing"
              @click.stop.prevent="unfollowActivityUser"
            >Unfollow</a>
          </li>
          <li v-if="canEditActivity">
            <a
              :disabled="isProcessing"
              @click.stop.prevent="editActivity"
            >Edit post</a>
          </li>
          <li v-if="activity.is_owner">
            <a
              :disabled="isProcessing"
              @click.stop.prevent="deleteActivity"
            >Remove post</a>
          </li>
          <li v-if="canReportActivity">
            <a
              :disabled="(activity.is_reported || isProcessing)"
              @click.stop.prevent="reportActivity"
            >
              <span v-if="activity.is_reported">Reported</span>
              <span v-else>Report</span>
            </a>
          </li>
        </ul>
      </template>
    </DuiContextMenu>

    <DActivityRemoval
      v-if="isDeletingActivity"
      :activity="isDeletingActivity"
      @activity-removed="activityRemoved"
      @dismiss="dismissActivityRemoval"
    />

    <DActivityReport
      v-if="isReportingActivity"
      :activity="isReportingActivity"
      @dismiss="dismissActivityReport"
    />

    <DActivityUnfollowUser
      v-if="isUnfollowingUser"
      :user="isUnfollowingUser"
      @dismiss="dismissUnfollowActivityUser"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import activityFeedService from '@d-services/activity-feed-service/activity-feed-service';
import Clipboard from '@d-shared/utils/clipboard';
import DActivityRemoval from './d-activity-removal/d-activity-removal.vue';
import DActivityReport from './d-activity-report/d-activity-report.vue';
import DActivityUnfollowUser from './d-activity-unfollow-user/d-activity-unfollow-user.vue';
import { getErrorMessage } from '@d-shared/utils/errors';

export default {
  components: {
    DActivityRemoval,
    DActivityReport,
    DActivityUnfollowUser,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    canEditActivity: false,
    canReportActivity: false,
    isDeletingActivity: null,
    isReportingActivity: null,
    isUnfollowingUser: null,
    isProcessing: false,
  }),
  mounted() {
    this.setCanEditActivity();
    this.setCanReportActivity();
  },
  methods: {
    copyLinkToPost() {
      this.$refs.contextMenu.toggleOpen(false);
      Clipboard.copyToClipboard(this.activity.url, document);
      Vue.duiNotificationManager.success('Post URL copied to clipboard.');
    },

    editActivity() {
      this.$refs.contextMenu.toggleOpen(false);
      this.$set(this.activity, 'isEditing', true);
    },

    setCanEditActivity() {
      if (!this.activity.is_owner) {
        return;
      }

      if (this.activity.type !== 'FeedPostActivity') {
        return;
      }

      this.$set(this, 'canEditActivity', true);
    },

    setCanReportActivity() {
      if (this.activity.is_owner) {
        return;
      }

      this.$set(this, 'canReportActivity', (this.activity.type === 'FeedPostActivity'));
    },

    // Delete activity
    async activityRemoved() {
      this.dismissActivityRemoval();
      await this.$nextTick();
      this.$emit('activity-removed');
    },

    deleteActivity() {
      this.$refs.contextMenu.toggleOpen(false);
      this.$set(this, 'isDeletingActivity', this.activity);
    },

    dismissActivityRemoval() {
      this.$set(this, 'isDeletingActivity', null);
    },
    // END Delect activity

    // Report activity
    dismissActivityReport() {
      this.$set(this, 'isReportingActivity', null);
    },

    reportActivity() {
      this.$refs.contextMenu.toggleOpen(false);
      this.$set(this, 'isReportingActivity', this.activity);
    },
    // END Report activity

    // Unfollow user
    dismissUnfollowActivityUser() {
      this.$set(this, 'isUnfollowingUser', null);
    },

    unfollowActivityUser() {
      this.$refs.contextMenu.toggleOpen(false);
      this.$set(this, 'isUnfollowingUser', this.activity.user);
    },
    // END Unfollow user
  },
};
</script>

<style lang="scss">
@import "@dui-styles/base";

.d-activity-actions {
  .dui-context-menu {
    .trigger .button .dui-icon {
      margin-bottom: -2px;
    }

    .options .tip {
      right: $_0-5em;
    }
  }
}
</style>
